import { render } from "./carousel.vue?vue&type=template&id=53db74a4"
import script from "./carousel.vue?vue&type=script&lang=js"
export * from "./carousel.vue?vue&type=script&lang=js"

import "./carousel.vue?vue&type=style&index=0&id=53db74a4&lang=scss"

import exportComponent from "/tmp/build_0d900136/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__